export class UpdateMPAPolicyRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "requiredApprovals",
            "baseName": "requiredApprovals",
            "type": "number",
            "format": ""
        },
        {
            "name": "approvalWindowHours",
            "baseName": "approvalWindowHours",
            "type": "number",
            "format": ""
        },
        {
            "name": "executionWindowHours",
            "baseName": "executionWindowHours",
            "type": "number",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceSelector",
            "baseName": "resourceSelector",
            "type": "MPAResourceSelector",
            "format": ""
        },
        {
            "name": "approverIdpId",
            "baseName": "approverIdpId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "approverProviderGroupId",
            "baseName": "approverProviderGroupId",
            "type": "string",
            "format": ""
        },
        {
            "name": "condition",
            "baseName": "condition",
            "type": "Condition",
            "format": ""
        },
        {
            "name": "updateCondition",
            "baseName": "updateCondition",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "exemptApiCredentials",
            "baseName": "exemptApiCredentials",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateMPAPolicyRequest.attributeTypeMap;
    }
    constructor() {
    }
}
